import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "40",
  height: "40",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M28 18.5v-3.7c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C25.72 10 24.88 10 23.2 10h-6.4c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C12 12.28 12 13.12 12 14.8v10.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C14.28 30 15.12 30 16.8 30H20"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M23 26.6c0-.56 0-.84.109-1.054a1 1 0 0 1 .437-.437C23.76 25 24.04 25 24.6 25h3.8c.56 0 .84 0 1.054.109a1 1 0 0 1 .437.437C30 25.76 30 26.04 30 26.6v.8c0 .56 0 .84-.109 1.054a1 1 0 0 1-.437.437C29.24 29 28.96 29 28.4 29h-3.8c-.56 0-.84 0-1.054-.109a1 1 0 0 1-.437-.437C23 28.24 23 27.96 23 27.4zM24.75 23.25a1.75 1.75 0 1 1 3.5 0V25h-3.5z"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }